<div *ngIf="loandata">
  <!-- Top Highlighted Key Financial Stats (Strict 4-Column Layout) -->
  <div class="row m-0 mb-3 loan-kpi-row" style="margin-left: -0.25rem !important; margin-right: -0.25rem !important;">
    <div class="col-3 p-1 mb-2">
      <div class="p-2 rounded h-100" style="background: color-mix(in srgb, var(--theme-primary, #123c53) 8%, #ffffff); border: 1px solid color-mix(in srgb, var(--theme-primary, #123c53) 20%, transparent);">
        <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem; letter-spacing: 0.5px;">Loan Amount</div>
        <div class="font-weight-bold text-primary" style="font-size: 1.15rem; color: var(--theme-primary, #123c53) !important;">
          ₹{{ loandata["Application_LoanAmount"] }}
        </div>
      </div>
    </div>
    
    <div class="col-3 p-1 mb-2">
      <div class="p-2 rounded h-100" style="background: #f0fdf4; border: 1px solid #bbf7d0;">
        <div class="small text-uppercase font-weight-bold text-success" style="font-size: 0.75rem; letter-spacing: 0.5px;">Loan EPI / EMI</div>
        <div class="font-weight-bold text-success" style="font-size: 1.15rem;">
          ₹{{ loandata["Application_LoanEMIAmount"] }}
        </div>
      </div>
    </div>

    <div class="col-3 p-1 mb-2">
      <div class="p-2 rounded h-100" style="background: #f8fafc; border: 1px solid #e2e8f0;">
        <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem; letter-spacing: 0.5px;">Agreement Value</div>
        <div class="font-weight-bold text-dark" style="font-size: 1.15rem;">
          ₹{{ loandata["Application_AgreementValue"] }}
        </div>
      </div>
    </div>

    <div class="col-3 p-1 mb-2">
      <div class="p-2 rounded h-100" style="background: #f8fafc; border: 1px solid #e2e8f0;">
        <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem; letter-spacing: 0.5px;">Loan Tenure</div>
        <div class="font-weight-bold text-dark" style="font-size: 1.15rem;">
          {{ loandata["Application_LoanTenure"] }} Months
        </div>
      </div>
    </div>
  </div>


  <!-- Detailed Metadata Grid (Strict 4-Column Layout) -->
  <div class="row m-0 p-2 rounded border" style="background: #ffffff; border-color: #e2e8f0 !important;">
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Application No</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["Application_No"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Loan Account No</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["LoanAcNo"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Branch Name</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["Branch_Name"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Product Name</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["Product_Name"] }}</div>
    </div>

    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Source Type</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["SourceType"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Branch Head</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["BranchHead"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Sales Executive</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["SalesExecutive"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Source Area</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["SourceArea"] }}</div>
    </div>

    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Asset Cost</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">₹{{ loandata["Application_AssetCost"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Interest Amount</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">₹{{ loandata["Application_InterestAmt"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Case IRR</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["Application_Case_IRR"] | number : "1.2-2" }}%</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">LTV %</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["Application_LTV"] }}%</div>
    </div>

    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Loan Date</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["Loan_Date"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">First EMI Date</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["First_EMI_Date"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Expiry Date</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["Expiry_Date"] }}</div>
    </div>
    <div class="col-3 p-2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.75rem;">Loan Purpose</div>
      <div class="font-weight-600 text-dark" style="font-size: 0.95rem;">{{ loandata["LoanPurpose"] }}</div>
    </div>
  </div>
</div>
